import { Component, OnInit, Input, Output, EventEmitter, ViewChild,TemplateRef } from '@angular/core';
import { appConfig } from 'src/app/_core/config/app-config.const';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { AuthService } from 'src/app/_services/auth.service';
import Swal from 'sweetalert2';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'tangram-playlist',
  templateUrl: './playlist.component.html',
  styleUrls: ['./playlist.component.scss']
})
export class PlaylistComponent implements OnInit {
  @ViewChild('AlertContent',  { static: true }) alertContent!: TemplateRef<any>;
  iconPath = appConfig.iconPath;
  @Input() playlist: any;
  @Input() isMediaCompleted: boolean = false;
  @Input() showCompletionCheckbox: boolean = false;
  // In draft mode the stat icons (views, users, rating, comments) are hidden
  // so the playlist row only shows the delete action next to the media meta.
  @Input() isDraft: boolean = false;
  @Output() onChangePlaylist = new EventEmitter();
  @Output() deleteMediaFromPlayList = new EventEmitter();
  @Output() onToggleMediaCompletion = new EventEmitter();
  previewVideoThumbnail: string = "assets/img/videos/img6.png"; // To store image url
  currentUser: any;
  alterMessage : string = ''
  currentMedia : string = ''
  mediaAverageRating: number = 0;

  constructor(
    private dashboardService: DashboardService,
    private authService: AuthService,
    private modalService: NgbModal
  ) {
    this.currentUser = this.authService.currentUserValue;
  }

  ngOnInit() {
    this.loadMediaRating();
  }

  loadMediaRating() {
    if (!this.currentUser || !this.playlist || !this.playlist._id) return;
    this.dashboardService.getMediaStarRating(this.playlist._id).subscribe((response: any) => {
      if (response.success) {
        this.mediaAverageRating = response.data.averageRating || 0;
      }
    });
  }
  toggleCompletion(event: any) {
    const isCompleted = event.target.checked;
    this.isMediaCompleted = isCompleted; // Update local state immediately
    this.onToggleMediaCompletion.emit({ videoId: this.playlist._id, isCompleted });
  }

  onPlaylistClick(playlist,event) {
    const targetElement = event.target
    if(targetElement.classList.contains('delete-btn')){
      return;
    }
    this.onChangePlaylist.emit(playlist);
  }
  
  showPopup(mediaId) {
    this.currentMedia = mediaId
    this.alterMessage = "Do you want to delete this media ?"
    this.modalService.open(this.alertContent, { centered: true, windowClass : 'unlock-premium' })

  }

  deleteMedia(){
    this.deleteMediaFromPlayList.emit(this.currentMedia)
    this.currentMedia = ''
  }

}
